import { render, staticRenderFns } from "./global-transactions-details.vue?vue&type=template&id=20e738b8&scoped=true&"
import script from "./global-transactions-details.vue?vue&type=script&lang=js&"
export * from "./global-transactions-details.vue?vue&type=script&lang=js&"
import style0 from "./global-transactions-details.vue?vue&type=style&index=0&id=20e738b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e738b8",
  null
  
)

export default component.exports